import { createSlice } from '@reduxjs/toolkit'

interface Key{
  value: string;
}

interface SearchArray{
  value: number;
}

interface MunicipalityArray{
  value: string;
}

interface SearchState {
  Key: ''
  Search: SearchArray[]
  Municipality: MunicipalityArray[]
}

const initialState: SearchState = {
  Key: '',
  Search: [],
  Municipality: []
};

export const SearchSlice = createSlice({
  name: 'Search',
  initialState,
  reducers: {

    KeySearchRedux: (state, action) => {
      state.Key = '';
      action.payload == '' ? state.Key = '' : state.Key = action.payload
    },

    SearchRedux: (state, action) => {
      state.Search = [];
      action.payload == '' ? state.Search = [] : state.Search.push(action.payload)
    },
   
    MunicipalityRedux: (state, action) => {
      state.Municipality = [];
      action.payload == '' ? state.Municipality = [] : state.Municipality.push(action.payload)
    }
  },
})

export const { KeySearchRedux, SearchRedux, MunicipalityRedux } = SearchSlice.actions
export default SearchSlice.reducer 